<template>

  <div   :class="{'bg-trader-red': image.highlight, 'bg-inactive': !image.highlight}" draggable="true"
       @dragstart="drag($event, image)">
    <!-- image -->
    <div v-if="showArticleNumberInput" @click="() => { if(!pageLocked) {onChangeActive(image);} }"
         class="h-20 w-full bg-contain bg-no-repeat bg-center relative">
      <div class=" h-20 w-full bg-contain bg-no-repeat bg-center "
           :style="[{'background-image' : 'url('+image.previewSmall+')'}]"
           :class="{'opacity-30' : !image.isActive, 'opacity-30' : image.isRemoved}"></div>

      <div class="absolute w-full h-full top-0 left-0 align-middle flex  justify-center flex-col">
        <div v-if="!image.isActive" class="align-middle justify-items-center justify-center">
          <p class="text-center text-shadow text-trader-base font-bold shadow-white dark:text-trader-signal-red dark:bg-[#303030A0]">
            INAKTIV</p>
        </div>

        <div v-if="image.isRemoved" class="align-middle justify-items-center justify-center">
          <p class="text-center text-shadow-lg text-[10pt] font-bold shadow-white dark:text-trader-signal-red dark:bg-[#303030A0]">
            WIRD ENTFERNT</p>
        </div>

        <div v-if="image.markedForDeletion"
             class="z-10 absolute top-0 right-0 h-[70px] w-[70px] flex justify-center items-center">
          <i class="fa-solid fa-x text-[70px] text-trader-signal-red"></i>
        </div>
      </div>
    </div>

    <div v-if="!showArticleNumberInput" @click="() => { if(!pageLocked) { sendImageData(image); } }"
         :class="['h-20', 'w-full', 'bg-contain', 'bg-no-repeat', 'bg-center', 'relative', { 'bg-trader-blue': index ===  selectedIndex}]">

      <div class=" h-20 w-full bg-contain bg-no-repeat bg-center "
           :style="[{'background-image' : 'url('+image.previewSmall+')'}]"
           :class="{'opacity-30' : !image.isActive, 'opacity-30' : image.isRemoved}"></div>

      <div class="absolute w-full h-full top-0 left-0 align-middle flex  justify-center flex-col">
        <div v-if="!image.isActive" class="align-middle justify-items-center justify-center">
          <p class="text-center text-shadow text-trader-base font-bold shadow-white dark:text-trader-signal-red dark:bg-[#303030A0]">
            INAKTIV</p>
        </div>

        <div v-if="image.isRemoved" class="align-middle justify-items-center justify-center">
          <p class="text-center text-shadow-lg text-[10pt] font-bold shadow-white dark:text-trader-signal-red dark:bg-[#303030A0]">
            WIRD ENTFERNT</p>
        </div>

        <div v-if="image.markedForDeletion"
             class="z-10 absolute top-0 right-0 h-[70px] w-[70px] flex justify-center items-center">
          <i class="fa-solid fa-x text-[70px] text-trader-signal-red"></i>
        </div>
      </div>
    </div>

    <!-- toolbar -->
    <div class="flex flex-col bg-white p-0.5">
      <div class="flex">
      <i @click="() => { onZoom(image, type); }"
         class="fa-solid fa-magnifying-glass p-1 hover:bg-active hover:text-white"
         title="Bildvorschau" data-ui="open-picture-preview"></i>

      <i v-if="!pageLocked" @click="() => { onRemove(image, type); }"
         class="fa-solid fa-xmark red p-1 hover:bg-active  hover:text-white"
         title="Bild aus Artikel entfernen" data-ui="delete-picture"></i>

      <i v-if="!pageLocked" @click="() => { onSetDelete(image, type); }"
         class="fa-solid fa-xmark p-1 text-red-800 hover:bg-active  hover:text-white"
         title="Bild auf löschen setzen" data-ui="set-delete-picture"></i>

      <i v-if="!pageLocked && !showArticleNumberInput" @click="() => { onChangeActive(image); }"
         class="fa-regular fa-eye-slash p-1  hover:bg-active  hover:text-white"
         title="Bild auf Inactive setzen" data-ui="set-delete-picture"></i>


      <div class="flex-grow"></div>

      <input @change="() => { onChangeDefault(image); }" v-if="!pageLocked && canBeDefault" type="checkbox"
             v-model="image.isDefault"
             title="Bild als Standardbild für diesen Artikel setzen">
      </div>

      <div v-if="userData?.isAdmin" class="flex justify-end">
        <button @click="() => openInPhotoshop(image)" class="bg-[#001e36] text-[#32aafd]  hover:text-[#001e36] hover:bg-[#32aafd] px-1 font-bold">Ps</button>
      </div>
    </div>

  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {mapState} from "vuex";
import {mutation} from "@/graphql";

export default {
  components: [FontAwesomeIcon],
  name: "ProductFormularImage",
  props: {
    onClickGetImage: {
      type: Function,
      default: () => {
      }
    },
    index: {
      type: Number,
      default: 0
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    showArticleNumberInput: {
      type: Boolean,
      default: false
    },
    image: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'picture'
    },
    onZoom: {
      type: Function,
      default: () => {
      }
    },
    onRemove: {
      type: Function,
      default: () => {
      }
    },
    onChangeDefault: {
      type: Function,
      default: () => {
      }
    },
    onChangeActive: {
      type: Function,
      default: () => {
      }
    },
    onSetDelete: {
      type: Function,
      default: () => {
      }
    },
    pageLocked: {
      type: Boolean,
      default: false
    },

    /*
    url: String,
    active: Boolean,
    imageId: Number,
    type: String,
    isDefault: {
      type: Boolean,
      default: false
    },
    */
    canBeDefault: {
      type: Boolean,
      default: false
    },
    onDragStart: {
      type: Function,
      default: () => {
      }
    },
    allowDrag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      highlightedPicture: 0,
    }
  },
  computed: {
    ...mapState('user', ['userData']),
  },
  methods: {
    async openInPhotoshop(image) {

      let type = image?.productLogoId > 0 ? 'logo' : 'picture'
      let pictureId = image.productLogoId || image.productPictureId

      const [result, err] = await mutation.openPictureInPhotoshop(type, pictureId)
      if (err) {
        console.error(err)
        return
      }

      
    },
    sendImageData(image) {
      this.highlightedPicture = image?.productJoinProductPictureId || image?.productJoinProductLogoId;
      this.onClickGetImage(image, this.index);
    },

    drag(event, picture) {
      
      if(!this.allowDrag) {
        return;
      }


      event.preventDefault(); // Standardverhalten verhindern
      const filePath = picture.originalFilePath;
      if (window?.electronAPI) {
        this.onDragStart();
        window?.electronAPI.startDrag(filePath); // Drag-Aktion starten
      }
    },
  },

  //
}

//
</script>

